import apiClient from './apiService';
import {PurchaseInvoice} from "@/types/invoice";

export const invoiceService = {

    getInvoiceDataCombined() {
        return apiClient.get('/invoice/combined');
    },
    // Fetch invoices
    getInvoice() {
        return apiClient.get('/invoice');
    },

    // Update an invoice
    updateInvoice(data: PurchaseInvoice | null) {
        if (data){
            data.attachments = [];
        }
        return apiClient.post('/invoice', data);
    },

};